// Funzione per convertire il colore hex in HSL
function hexToHSL(hex) {
  // Rimuovere il simbolo #
  hex = (hex || "").replace("#", "");
  // Convertire in valori RGB
  let r = parseInt(hex.substring(0, 2), 16) / 255;
  let g = parseInt(hex.substring(2, 4), 16) / 255;
  let b = parseInt(hex.substring(4, 6), 16) / 255;

  // Trovare il valore massimo e minimo tra R, G, B
  let max = Math.max(r, g, b);
  let min = Math.min(r, g, b);
  let h,
    s,
    l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // Achromatic
  } else {
    let d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
        console.error("Unexpected value in switch statement");
        return null
    }
    h /= 6;
  }
  return { h: h * 360, s: s, l: l };
}

// Funzione per convertire HSL in RGB
function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

// Funzione per convertire il colore HSL in hex
function HSLToHex(h, s, l) {
  h /= 360;
  let r, g, b;

  if (s === 0) {
    r = g = b = l; // Achromatic
  } else {
    let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    let p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return (
    "#" +
    Math.round(r * 255)
      .toString(16)
      .padStart(2, "0") +
    Math.round(g * 255)
      .toString(16)
      .padStart(2, "0") +
    Math.round(b * 255)
      .toString(16)
      .padStart(2, "0")
  );
}

// Funzione principale per regolare il colore hex
export function adjustHexColor(hex) {
  // Convertire il colore hex in HSL
  let hsl = hexToHSL(hex);

  // Controllo che la conversione sia andata a buon fine
  if (!hsl) {
    console.error("Valore hex non valido:", hex);
    return hex; // oppure return null;
  }

  // Diminuire saturazione e luminosità del 10%
  hsl.s = Math.max(0, hsl.s - 0.1);
  hsl.l = Math.max(0, hsl.l - 0.1);

  // Convertire di nuovo in hex
  return HSLToHex(hsl.h, hsl.s, hsl.l);
}

const hexToRgb = (hex) => {
  const bigint = parseInt(hex.slice(1), 16);
  return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
};

const rgbToHsl = (r, g, b) => {
  r /= 255;
  g /= 255;
  b /= 255;
  const max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  let h = 0,
    d = max - min;
  if (d) {
    h =
      max === r
        ? (g - b) / d + (g < b ? 6 : 0)
        : max === g
          ? (b - r) / d + 2
          : (r - g) / d + 4;
    h /= 6;
  }
  return h * 360;
};

export const calculateHueRotation = (startHex, endHex) => {
  const [r1, g1, b1] = hexToRgb(startHex);
  const [r2, g2, b2] = hexToRgb(endHex);
  const h1 = rgbToHsl(r1, g1, b1);
  const h2 = rgbToHsl(r2, g2, b2);
  return (h2 - h1 + 360) % 360; // Assicura che l'angolo sia positivo
};
